import { SlidersHorizontalIcon } from "@phosphor-icons/react";

import useLeadsSearchParams from "features/leads/hooks/useLeadsSearchParams";

import { Button } from "common/components/ui/Button";

import FiltersSelection from "./FiltersSelection";

import type { FiltersProps } from "./FiltersSelection";

export default function DesktopFilters({
  searchParams,
  setSearchParams,
}: FiltersProps) {
  const { hasFilters, resetFilters } = useLeadsSearchParams(
    searchParams,
    setSearchParams,
  );

  return (
    <div className="flex flex-col rounded-3xl border border-black-200">
      <div className="flex items-center gap-x-2 border-b border-black-200 p-3">
        <div className="rounded-xl bg-black-100 p-2">
          <SlidersHorizontalIcon size={16} />
        </div>
        <span className="mr-auto text-sm-bold">Filters</span>
        {hasFilters && (
          <Button variant="link-danger" size="sm" onClick={resetFilters}>
            Clear all
          </Button>
        )}
      </div>

      <div className="py-1.5">
        <FiltersSelection
          searchParams={searchParams}
          setSearchParams={setSearchParams}
        />
      </div>
    </div>
  );
}
